import { useTranslation } from 'react-i18next';
import isEmail from 'validator/lib/isEmail';
import { isValidPhoneNumber } from 'utils/phone/isValidPhoneNumber';

export const useTranslatedValidation = () => {
  const { t } = useTranslation(['common']);

  return {
    required: value =>
      value ? undefined : t('common:validation.requiredField'),

    isValidEmail: value => {
      if (!value) {
        return undefined;
      }
      return isEmail(value) ? undefined : t('common:validation.invalidEmail');
    },
    isValidPhone: value => {
      if (!value) {
        return undefined;
      }
      const countryCode = t('common:countryCode');
      return isValidPhoneNumber(value, countryCode)
        ? undefined
        : t('common:validation.invalidPhone');
    },
    hasXcharacters: (nb: number) => value => {
      if (!value) {
        return undefined;
      }
      return value.length !== nb
        ? t('common:validation.hasXcharacters', { nb })
        : undefined;
    },
    hasXcharactersOrLess: (nb: number) => value => {
      if (!value) {
        return undefined;
      }
      return value.length > nb
        ? t('common:validation.hasXcharactersOrLess', { nb })
        : undefined;
    },
    hasXcharactersOrMore: (nb: number) => value => {
      if (!value) {
        return undefined;
      }
      return value.length < nb
        ? t('common:validation.hasXcharactersOrMore', { nb })
        : undefined;
    },
  };
};
